import React from 'react';
import { Modal } from '../../components';
interface TermsAcceptanceModalProps {
    showDeliverooInfo: boolean;
    handleClose: () => void;
}

const sectionTitleStyle: React.CSSProperties = {
    fontSize: '1.2rem',
    marginBottom: '10px',
    borderBottom: '1px solid #eee',
    paddingBottom: '5px',
};

const sectionStyle: React.CSSProperties = {
    marginBottom: '25px',
};

const listStyle: React.CSSProperties = {
    paddingLeft: '25px',
    listStyleType: 'disc',
    color: 'black',
    margin: '15px 0',
};

const TermsAcceptanceModal: React.FC<TermsAcceptanceModalProps> = ({
    showDeliverooInfo,
    handleClose
}) => {

    const renderSection = (title: string, content: React.ReactNode) => (
        <section style={sectionStyle}>
            <h2 style={sectionTitleStyle}>{title}</h2>
            {content}
        </section>
    );

    return showDeliverooInfo ? (
        <Modal
            isOpen
            color="secondary"
            title="Conditions Générales d'Utilisation du Service Deliveroo Express"
            header
            width="600px"
            fixed
            btnTxt="Retour"
            handleClose={handleClose}
            onClick={handleClose}
        >
            <div
                className="terms-content"
                style={{ maxHeight: '60vh', overflowY: 'auto', padding: '0 15px' }}
            >

                {renderSection('1. Objet et champ d\'application', (
                    <>
                        <p>
                            Les présentes Conditions Générales d'Utilisation ("CGU") ont pour objet de définir les modalités selon lesquelles
                            la société Dishop permet aux restaurants partenaires (ci-après le "Restaurant") d'accéder à un module additionnel
                            de livraison à la demande via la flotte Deliveroo Express, intégrée à la plateforme Dishop.
                        </p>
                        <p>
                            L'utilisation de ce module est indépendante du contrat principal de fourniture de la solution de commande
                            en marque blanche conclu entre Dishop et le Restaurant. En aucun cas l'utilisation de Deliveroo Express ne
                            saurait affecter, modifier ou altérer les engagements du contrat principal.
                        </p>
                    </>
                ))}

                {renderSection('2. Définitions', (
                    <ul style={listStyle}>
                        <li><strong>Commande</strong> : commande client initiée via la plateforme en marque blanche fournie par Dishop.</li>
                        <li><strong>Site</strong> : localisation opérationnelle du Restaurant.</li>
                        <li><strong>Livreur</strong> : prestataire indépendant mis à disposition par Deliveroo Express.</li>
                        <li><strong>Fermeture de Site</strong> : suppression du droit d'utiliser Deliveroo Express pour un Site donné.</li>
                        <li><strong>Zone Closure</strong> : fermeture d'une zone géographique par Deliveroo.</li>
                    </ul>
                ))}

                {renderSection('3. Description du service', (
                    <>
                        <p>
                            Le Restaurant accède via Dishop à un service de livraison fourni par Deliveroo Express, permettant la mise en
                            relation avec des livreurs indépendants selon les critères suivants :
                        </p>
                        <ul style={listStyle}>
                            <li>Distance maximale : 7 km</li>
                            <li>Poids maximal : 10 kg</li>
                            <li>Volume maximal : 44 litres</li>
                        </ul>
                        <p>
                            Aucune relation contractuelle ou commerciale n'existe entre le Restaurant et Deliveroo.
                            L'intégration est gérée exclusivement par Dishop.
                        </p>
                    </>
                ))}

                {renderSection('4. Processus de commande et obligations du Restaurant', (
                    <>
                        <p>Le Restaurant s'engage à :</p>
                        <ul style={listStyle}>
                            <li>Emballer de manière sûre et conforme les produits commandés ;</li>
                            <li>Indiquer le numéro de commande sur l'emballage ;</li>
                            <li>Respecter l'heure de retrait prévue ("Pick-Up Time") ;</li>
                            <li>Ne pas proposer de produits interdits (ex : tabac, alcool sans autorisation, animaux).</li>
                        </ul>
                        <p>
                            Des <strong>frais d'attente</strong> de 0,35 € par minute sont applicables dès la 4<sup>e</sup> minute d'attente du livreur sur place.
                        </p>
                    </>
                ))}

                {renderSection('5. Responsabilité et renonciation à recours', (
                    <>
                        <p>Le Restaurant reconnaît que :</p>
                        <ul style={listStyle}>
                            <li>Dishop ne garantit pas la disponibilité continue ou en temps réel de livreurs indépendants via le service Deliveroo Express ;</li>
                            <li>Dishop <strong>ne saurait être tenu responsable</strong> d'un quelconque dysfonctionnement ou échec de livraison (retard, annulation, perte, vol, casse).</li>
                            <li>Deliveroo et ses livreurs sont également <strong>dégagés de toute responsabilité</strong> à l'égard du Restaurant.</li>
                        </ul>
                        <p>
                            Le Restaurant <strong>renonce expressément et définitivement</strong> à toute forme de réclamation, dédommagement ou action en justice relative à la prestation de livraison.
                        </p>
                    </>
                ))}

                {renderSection('6. Prix et frais', (
                    <>
                        <p>
                            Le prix global des livraisons réalisées sur la période sera mentionné dans la facture périodique habituelle
                            (bi-mensuelle), accessible dans l’onglet "Facture" du back-office Dishop.
                        </p>
                        <p>
                            En cas d’annulation postérieure à l’attribution du livreur, <strong>la totalité des frais de livraison reste due</strong>.
                        </p>
                        <p>
                            Les frais d'attente sont facturés à partir de la 4<sup>e</sup> minute, à hauteur de 0,35 €/minute,
                            et s’ajoutent au prix initial de la course.
                        </p>
                    </>
                ))}

                {renderSection('7. Paiement des livraisons', (
                    <>
                        <p>
                            Les commandes livrées via le service Deliveroo Express doivent obligatoirement être réglées en ligne par le consommateur final.
                        </p>
                        <p>
                            Dans le cadre de la transaction effectuée sur la solution de commande en marque blanche,
                            Dishop prélève automatiquement le coût total TTC de la livraison.
                        </p>
                    </>
                ))}

                {renderSection('8. Durée, suspension et résiliation', (
                    <>
                        <p>Ces CGU sont à durée indéterminée.</p>
                        <p>Le service peut être suspendu ou résilié par Dishop :</p>
                        <ul style={listStyle}>
                            <li>avec un <strong>préavis de 160 jours</strong>, à sa seule discrétion et sans motif ;</li>
                            <li>avec un <strong>préavis de 15 jours</strong> en cas de fermeture de zone (<em>Zone Closure</em>) par Deliveroo ;</li>
                            <li><strong>immédiatement</strong>, en cas de comportement inapproprié du personnel du Restaurant envers un livreur.</li>
                        </ul>
                        <p>Dishop ne pourra être tenu responsable des conséquences économiques de cette résiliation.</p>
                    </>
                ))}

                {renderSection('9. Conformité et restrictions', (
                    <>
                        <p>
                            Le Restaurant s’engage à ne proposer que des produits autorisés par la réglementation en vigueur et par les règles de Deliveroo
                            (produits non restreints, conformité sanitaire, etc.).
                        </p>
                        <p>
                            Le Restaurant est invité à consulter les politiques officielles de Deliveroo, notamment celles relatives aux produits interdits
                            et aux exigences opérationnelles :
                            <br />
                            <a
                                href="https://restaurants.deliveroo.com/fr-fr/policies#Politique%20relative%20aux%20%C3%89l%C3%A9ments%20de%20Menu%20soumis%20%C3%A0%20restrictions"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                https://restaurants.deliveroo.com/fr-fr/policies#...
                            </a>
                        </p>
                    </>
                ))}

                {renderSection('10. Propriété intellectuelle', (
                    <p>
                        Le logo Deliveroo apparaissant dans le back-office est utilisé dans le cadre d'une licence d’usage limitée.
                        Toute utilisation du logo à des fins promotionnelles ou marketing est interdite sans autorisation préalable écrite.
                    </p>
                ))}

                {renderSection('11. Données personnelles', (
                    <p>
                        Le Restaurant n’a accès qu’aux informations strictement nécessaires à la bonne exécution de la livraison.
                        Aucune donnée relative au livreur ne reste accessible après la livraison.
                    </p>
                ))}

                {renderSection('12. Force majeure', (
                    <p>
                        Dishop ne pourra être tenue responsable en cas d’indisponibilité du service liée à un cas de force majeure :
                        grève, pénurie, panne réseau, etc.
                    </p>
                ))}

                {renderSection('13. Limitation de responsabilité', (
                    <p>En tout état de cause, la responsabilité de Dishop est expressément exclue.</p>
                ))}

                {renderSection('14. Droit applicable et juridiction compétente', (
                    <p>
                        Les présentes CGU sont soumises au droit français. Tout litige relève de la compétence exclusive des tribunaux de Paris.
                    </p>
                ))}

                {renderSection('15. Acceptation', (
                    <p>
                        En activant le module de livraison Deliveroo Express via la plateforme Dishop,
                        le Restaurant reconnaît avoir lu et accepté l’intégralité des présentes Conditions Générales d’Utilisation.
                    </p>
                ))}

            </div>
        </Modal>
    ) : null;
};

export default TermsAcceptanceModal;
